var $ab40087f10d0e568$exports = {};
$ab40087f10d0e568$exports = {
    "pending": `gaida`
};


export {$ab40087f10d0e568$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
